module.exports = __webpack_public_path__ + "media/theme/blog__ico-close-3-1de9be31.png";